const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Escapes a value for HTML text or a quoted attribute, for markup built as a string (e.g. the
 * mention tags ment.io pastes). Names and image URLs are user-controlled and stored unvalidated.
 */
app.factory('escapeHtml', [function() {
  var entities = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
  return function(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
      return entities[character];
    });
  };
}]);
